import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export class SlotNumber {
  constructor() {
    this.init();
  }

  init() {
    const slots = document.querySelectorAll('.num-slot');
    slots.forEach(slot => {
      const rawValue = String(slot.dataset.value || '');

      const isOnce = slot.classList.contains('slot-once');
      const isReverse = slot.classList.contains('slot-reverse');
      const isScrollSync = slot.classList.contains('slot-scrollsync');
      const useComma = slot.classList.contains('use-comma');
      const useDecimal = slot.classList.contains('use-decimal');

      const formatted = formatValue(rawValue, useComma, useDecimal);
      const chars = formatted.split('');

      slot.innerHTML = '';
      const rollers = [];

      for (const ch of chars) {
        if (/\d/.test(ch)) {
          const digit = parseInt(ch);
          const container = document.createElement('div');
          container.className = 'digit-container';

          const roller = document.createElement('div');
          roller.className = 'digit-roller';

          for (let i = 0; i <= 9; i++) {
            const digitDiv = document.createElement('div');
            digitDiv.className = 'digit';
            digitDiv.textContent = i;
            roller.appendChild(digitDiv);
          }

          container.appendChild(roller);
          slot.appendChild(container);
          rollers.push({ roller, digit });
        } else {
          const type = ch === ',' ? 'comma' : (ch === '.' ? 'decimal' : 'other');
          const staticDiv = document.createElement('div');
          staticDiv.className = `digit-static ${type}`;
          staticDiv.textContent = ch;
          slot.appendChild(staticDiv);
        }
      }

      if (isScrollSync) {
        rollers.forEach(({ roller, digit }) => {
          const digitHeight = roller.querySelector('.digit')?.offsetHeight || 0;
          const maxY = -digit * digitHeight;
http://192.168.1.218:8051/works/314
          ScrollTrigger.create({
            trigger: slot,
            start: 'top 80%',
            end: 'top 40%',
            scrub: true,
            onUpdate: self => {
              gsap.set(roller, { y: maxY * self.progress });
            }
          });
        });
      } else {
        ScrollTrigger.create({
          trigger: slot,
          start: 'top 80%',
          toggleActions: isOnce ? 'play none none none' : 'play reverse play reverse',
          onEnter: () => animateRollers(rollers, true),
          onLeaveBack: () => {
            if (isReverse) animateRollers(rollers, false);
          }
        });
      }
    });
  }
}

function animateRollers(rollers, forward = true) {
  rollers.forEach(({ roller, digit }) => {
    const digitHeight = roller.querySelector('.digit')?.offsetHeight || 0;
    const y = forward ? -digit * digitHeight : 0;

    gsap.to(roller, {
      y,
      ease: 'none',
      duration: 0.8
    });
  });
}

// カンマや小数点を付ける処理（必要に応じて拡張してください）
function formatValue(raw, useComma, useDecimal) {
  // 数値処理せずに文字列で扱う
  let str = raw.toString();

  if (useComma) {
    // カンマ対応：整数部と小数部に分けて処理
    const parts = str.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    str = parts.join('.');
  }

  return str;
}

export function initSlotNumber() {
  new SlotNumber();
}